import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  APPROVE_STATUS_R,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_ARE,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_EDIT,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_REJECT_CANCEL,
  AUTH_STATUS_REPLACE,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  CLIENT_TYPE_CONST,
} from "constants/FormatDataContanst";

export const getInvoiceStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: t("auth_status.init"),
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      //"Chờ phát hành"
      text: t("auth_status.progressing"),
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_REJECT]: {
      //"Từ chối phát hành",
      text: t("auth_status.reject"),
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_APPROVE]: {
      //"Đã phát hành",
      text: t("auth_status.approve"),
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_REPLACE]: {
      //"Thay thế",
      text: t("auth_status.replace"),
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_EDIT]: {
      //"Điều chỉnh",
      text: t("auth_status.edit"),
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_CANCEL]: {
      //"Hủy",
      text: t("auth_status.cancel"),
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_CANCEL_WAITING]: {
      //"Hủy",
      text: "Chờ duyệt hủy",
      badgeColor: "badge-soft-warning",
    },

    [AUTH_STATUS_REJECT_CANCEL]: {
      //"Từ chối hủy",
      text: "Từ chối hủy",
      badgeColor: "badge-soft-danger",
    },

    [AUTH_STATUS_RR]: {
      //"Từ chối tiếp nhận đăng ký",
      text: t("auth_status.rr"),
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_RRE]: {
      //"Từ chối tiếp nhận thay đổi"
      text: t("auth_status.rre"),
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_AR]: {
      // Đã tiếp nhận đăng ký
      text: t("auth_status.ar"),
      badgeColor: "badge-soft-info",
    },
    [AUTH_STATUS_ARE]: {
      // Đã tiếp nhận thay đổi
      text: t("auth_status.are"),
      badgeColor: "badge-soft-info",
    },
  };

  const PROGRESS_STATUS = {
    1: {
      //"Lưu tạm",
      text: "Chưa được gửi đi TCT",
      badgeColor: "badge-soft-info",
    },
    2: {
      //"Lưu tạm",
      text: "Đang đính kèm trong 1 bảng tổng hợp",
      badgeColor: "badge-soft-info",
    },
    3: {
      //"Lưu tạm",
      text: "Đã gửi trong 1 bảng tổng hợp",
      badgeColor: "badge-soft-info",
    },
    4: {
      //"Lưu tạm",
      text: "Đã gửi thẳng TCT",
      badgeColor: "badge-soft-info",
    },
  };

  const APPROVE_STATUS = {
    [APPROVE_STATUS_M]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-info",
    },
    [APPROVE_STATUS_P]: {
      //""Gửi chờ duyệt",",
      text: "Gửi chờ duyệt",
      badgeColor: "badge-soft-warning",
    },
    [APPROVE_STATUS_A]: {
      //"Đã duyệt",
      text: "Đã duyệt",
      badgeColor: "badge-soft-success",
    },
    [APPROVE_STATUS_R]: {
      //"Từ chối duyệt",
      text: "Từ chối duyệt",
      badgeColor: "badge-soft-danger",
    },
  };

  const CLIENT_TYPE = {
    [CLIENT_TYPE_CONST.SALE]: {
      text: "HĐ GTGT bình thường",
      badgeColor: "badge-soft-info",
    },
    [CLIENT_TYPE_CONST.SALE_ADJ]: {
      text: "HĐ GTGT Điều chỉnh giảm",
      badgeColor: "badge-soft-info",
    },
    [CLIENT_TYPE_CONST.IBT_GTGT]: {
      text: "PXK trường hợp ngoại tỉnh",
      badgeColor: "badge-soft-info",
    },
    [CLIENT_TYPE_CONST.GRA]: {
      text: "HĐ GTGT Trả hàng cho NCC",
      badgeColor: "badge-soft-info",
    },
    [CLIENT_TYPE_CONST.GRA_ADJ]: {
      text: "HĐ GTGT Trả hàng cho NCC điều chỉnh giảm",
      badgeColor: "badge-soft-info",
    },
    [CLIENT_TYPE_CONST.IBT]: {
      text: "Phiếu xuất kho bình thường",
      badgeColor: "badge-soft-primary",
    },
    [CLIENT_TYPE_CONST.IBT_CSM]: {
      text: "Phiếu xuất kho có hàng consignment",
      badgeColor: "badge-soft-primary",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
    PROGRESS_STATUS: PROGRESS_STATUS,
    APPROVE_STATUS: APPROVE_STATUS,
    CLIENT_TYPE: CLIENT_TYPE,
  };
};

export const operatorsHelper = {
  "+": function (a, b) {
    return a + b;
  },
  "-": function (a, b) {
    return a - b;
  },
};
